import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import { Button, Typography } from "@mui/material";
import Image from '../Image';
import styles from './EmptyState.module.css';

const EmptyState = (props) => {
  const {
    image,
    title,
    subtitle,
    primaryAction,
    secondaryAction,
    titleProps,
    subtitleProps,
    position,
  } = props;
  const { className: imgClassName, ...otherImageProps } = image || {};

  const primaryActionMarkup = primaryAction ? <Button color="primary" {...primaryAction} /> : null;

  const secondaryActionMarkup = secondaryAction ? (
    <Button color="primary" {...secondaryAction} />
  ) : null;

  const renderActions = () =>
    primaryAction || secondaryAction ? (
      <div className={styles.actions}>
        {secondaryActionMarkup}
        {primaryActionMarkup}
      </div>
    ) : null;

  return (
    <div
      style={{ position }}
      className={cn({
        [styles.root]: true,
        center: position === 'fixed' || position === 'absolute',
      })}
    >
      {image && <Image className={cn(styles.img, imgClassName)} {...otherImageProps} />}
      {title && (
        <Typography variant="h5" textAlign="center" {...titleProps}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="h6" textAlign="center" {...subtitleProps}>
          {subtitle}
        </Typography>
      )}
      {renderActions()}
    </div>
  );
};

EmptyState.propTypes = {
  position: Type.oneOf(['static', 'absolute', 'relative', 'fixed']),
  image: Type.shape(Image.propTypes),
  title: Type.string,
  subtitle: Type.string,
  primaryAction: Type.object, // eslint-disable-line react/forbid-prop-types,
  secondaryAction: Type.object, // eslint-disable-line react/forbid-prop-types,
  titleProps: Type.object, // eslint-disable-line react/forbid-prop-types,
  subtitleProps: Type.object, // eslint-disable-line react/forbid-prop-types,
};

EmptyState.defaultProps = {
  position: 'fixed',
  image: null,
  title: '',
  subtitle: '',
  titleProps: {},
  subtitleProps: {},
  primaryAction: null,
  secondaryAction: null,
};

export default EmptyState;
